import { useEffect, useState } from "react";
import {
	Box,
	Container,
	Heading,
	Image,
	Stack,
	Text,
} from "@chakra-ui/react";
import { useCmsApi } from "../../services/useCmsApi";

const DEFAULT_HOW_IT_WORKS_HEADING = "How Geco Works";

export const HowItWorksSection = (): JSX.Element => {
	const cmsApi = useCmsApi();
	const [heading, setHeading] = useState(DEFAULT_HOW_IT_WORKS_HEADING);

	useEffect(() => {
		cmsApi.getSiteSetting("howItWorksHeading").then((s) => { if (s?.value) setHeading(s.value); });
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	return (
	<Box py={{ base: "16", md: "24" }}>
		<Container maxW="1480px">
			<Stack spacing="10">
				<Stack spacing="4" textAlign="center" maxW="3xl" mx="auto" align="center">
					<Heading size={{ base: "sm", md: "xl" }} color="gray.800">
						{heading}
					</Heading>
					<Text color="gray.600" fontSize={{ base: "lg", md: "xl" }} maxW="2xl" mx="auto">
						Geco provides a simple, farm-friendly program that draws on hundreds of satellite images over five years to estimate how weed pressure is changing over time.
					</Text>
				</Stack>
				<Image
					src="/case-studies/case2/Fahlman Field 3_five_year_weed_pressure_maps_one_row_presentation.png"
					loading="lazy"
					alt="Multi-year weed pressure map sequence"
					maxW={{ base: "100%", lg: "1040px" }}
					w="full"
					mx="auto"
					display="block"
					borderRadius="lg"
					border="1px solid"
					borderColor="gray.200"
				/>
				<Stack spacing="5" maxW="5xl" mx="auto">
					<Text color="gray.700" fontSize={{ base: "md", md: "lg" }}>
						Prediction combines historical patterns with current-season crop and weed conditions to identify where weed patches are likely to emerge.
					</Text>
					<Image
						src="/case-studies/case2/Fahlman Field 3_spray_map_options.png"
						loading="lazy"
						alt="Prescription map showing targeted weed zones"
						maxW={{ base: "280px", md: "400px" }}
						w="full"
						mx="auto"
						display="block"
						borderRadius="lg"
						border="1px solid"
						borderColor="gray.200"
					/>
					<Text color="gray.700" fontSize={{ base: "md", md: "lg" }}>
						Easy-to-use prescription maps load into your existing equipment, helping you apply appropriate rates of inputs where they&apos;re needed for weed control.
					</Text>
				</Stack>
			</Stack>
		</Container>
	</Box>
	);
};
